import React, { PureComponent } from 'react';
import { IReducerState } from '../../states/renditionStates';
import commonStore from '../../store/commonStore.js';
import { connect } from 'react-redux';
import UserAgentUtils from '../../utils/general/userAgentUtils';
import { openLink, openNewTestPage, openViewReadingList, saveReportForOffline } from '../../utils/api/appControl';
import { switchPage } from '../../utils/api/pageControl';
import { RenditionLoadable } from '../../utils/general/LoadableRelated';
import { checkDomEntitlement } from '../../utils/general/checkDomEntitlement';
import { isPreview, isCVMobileApp, parseToBoolean } from '../../utils/general/general';
import $ from 'jquery';
import { RSCH_HTML_TRACKING_CONFIG } from '../../readership/trackingConfig';
import { enterKeyPressed } from '../../utils/general/enterKey';

interface IMoreProps {
    docHeaderSectionJson: any;
    initialData: any;
    hiddenText?: boolean;
    hiddenReadingList?: boolean;
    hiddenSaveReport?: boolean;
    title?: string;
    containerStyle?: React.CSSProperties;
    contentStyle?: React.CSSProperties;
    showOldBranding?: boolean
}

const FormPopup = RenditionLoadable({
    loader: () => import('../../modalrelated/formPopup'),
}, "formPopup", Date.now());

export class More extends PureComponent<IMoreProps, any> {
    public SHARE_SAVE: any;
    public OFFLINE_READING_WEB: any;
    public OFFLINE_READING_MOBILE: any;
    public SHARE_MANAGE_SUBSCRIPTIONS: any;
    public SHARE_FEEDBACK: any;
    public SHARE_UPDATE_CONTACT_DETAILS: any;
    public SHARE_HELP: any;
    public SHARE_COOKIES_POLICY: any;
    public SHARE_PRIVACY_POLICY: any;
    public COMPATIBILITY_TEST: any;

    constructor(props: IMoreProps) {
        super(props);
        this.state = {
            modalStatus: false
        };
        this.SHARE_SAVE = React.createRef();
        this.OFFLINE_READING_WEB = React.createRef();
        this.OFFLINE_READING_MOBILE = React.createRef();
        this.SHARE_MANAGE_SUBSCRIPTIONS = React.createRef();
        this.SHARE_FEEDBACK = React.createRef();
        this.SHARE_UPDATE_CONTACT_DETAILS = React.createRef();
        this.SHARE_HELP = React.createRef();
        this.SHARE_COOKIES_POLICY = React.createRef();
        this.SHARE_PRIVACY_POLICY = React.createRef();
        this.COMPATIBILITY_TEST = React.createRef();
    }

    public componentDidMount() {
        this.checkCurrentCompoentDOMEntit();
        $('#shareTabPaneContent .x-rsch-hyperlink').click( () => {
            setTimeout(() => {
                $('#floatLeftPartMenu .nav li').removeClass('hover');
            }, 100);
        });
    }

    public checkCurrentCompoentDOMEntit() {
        this.SHARE_SAVE.current && checkDomEntitlement(this.SHARE_SAVE.current);
        this.OFFLINE_READING_WEB.current && checkDomEntitlement(this.OFFLINE_READING_WEB.current);
        this.OFFLINE_READING_MOBILE.current && checkDomEntitlement(this.OFFLINE_READING_MOBILE.current);
        this.SHARE_MANAGE_SUBSCRIPTIONS.current && checkDomEntitlement(this.SHARE_MANAGE_SUBSCRIPTIONS.current);
        this.SHARE_FEEDBACK.current && checkDomEntitlement(this.SHARE_FEEDBACK.current);
        this.SHARE_UPDATE_CONTACT_DETAILS.current && checkDomEntitlement(this.SHARE_UPDATE_CONTACT_DETAILS.current);
        this.SHARE_HELP.current && checkDomEntitlement(this.SHARE_HELP.current);
        this.SHARE_COOKIES_POLICY.current && checkDomEntitlement(this.SHARE_COOKIES_POLICY.current);
        this.SHARE_PRIVACY_POLICY.current && checkDomEntitlement(this.SHARE_PRIVACY_POLICY.current);
        this.COMPATIBILITY_TEST.current && checkDomEntitlement(this.COMPATIBILITY_TEST.current);
    }

    public showSaveMobile() {
        return this.showSaveOptionForOfflineUser() && this.showOfflineReadingOption();
    }

    public showSave() {
        return this.showCopyUnderHeadline();
    }

    public showSaveOptionForOfflineUser() {
        const _HTML_RENDITION = commonStore.getState().asyncStateReducer.initialData;
        return _HTML_RENDITION.isAppCached;
    }

    public showCopyUnderHeadline() {
        if (isCVMobileApp() || isPreview()) {
            return false;
        }
        const { validVendorBankCustomer, validPWMBroker, validVendorBanker } = this.props.initialData;
        if (!parseToBoolean(this.props.docHeaderSectionJson.issuerPage?.financialsBlock?.showPrint)) {
            return false;
        }
        // if(deviceInfoService.getDeviceType() == 'mobile' || $scope.isSmartPhone()) {
        //     return "false";
        // }

        if (validVendorBankCustomer || validVendorBanker || validPWMBroker) {
            return false;
        }
        if (this.offlineEntitledFunc()) {
            return false;
        }
        return parseToBoolean(this.props.docHeaderSectionJson.issuerPage.financialsBlock.showPrint);
    }

    public offlineEntitledFunc() {
        return this.props.initialData.isEntitled('OFFLINE_READING');
    }

    public showCopyUnderShareTab() {
        if (isPreview()) {
            return false;
        }
        return this.props.docHeaderSectionJson.issuerPage?.financialsBlock?.showPrint === 'true';
    }

    public showOfflineReadingOption() {
        return this.showCopyUnderShareTab();
    }

    public showManageSubscription() {
        return !UserAgentUtils.isInsideCVApp.any();
    }

    public showCompatibilityTest() {
        return !UserAgentUtils.isInsideCVApp.any();
    }

    public showUpdateContactDetails() {
        if (isPreview()) {
            return false;
        }
        return this.props.docHeaderSectionJson.issuerPage
            && this.props.docHeaderSectionJson.issuerPage.financialsBlock
            && this.props.docHeaderSectionJson.issuerPage.financialsBlock.showUpdateContactDetails === 'true';
}

    public openModal(e: any) {
        RSCH_HTML_TRACKING_CONFIG.trackUpdateContactDetailsClick();
        e.stopPropagation();
        // Improtant!!! you must setState in below if else to avoid cause reRender!
        if (e.target.id === "modalClose" || e.target.getAttribute('data-btn') === 'close') { // Improtant!!! if you want close modal in more case only change this if
            this.setState({
                modalStatus: false,
            });
            $('#leftMenuMoreTabLi').focus();
        } else if (this.state.modalStatus === false) { // Improtant!!! don't change this if in any case
            this.setState({
                modalStatus: true,
            });
        }
    }

    public render() {
        const { docHeaderSectionJson, hiddenText, hiddenReadingList, title, containerStyle, contentStyle, hiddenSaveReport } = this.props;
        const iconClass = this.props.showOldBranding ? 'icon-sprite' : 'rebrand icon-rebrand';
        const isJP = this.props.docHeaderSectionJson?.metadata?.isJP;
        const chooseAnAction = isJP ? "何をするか選択" : "Choose An Action";
        return <span id="shareTabPaneContent" className="paneContent">
            <div className="shareTab" style={containerStyle}>
                <h2 className="choose_an_action_title" id="choose_an_action_title_id">{title || chooseAnAction }</h2>
                <div className="hline" id="hline_id"></div>
                <div style={{ marginLeft: '20px', ...contentStyle }}>
                    {this.showSaveMobile() && (
                        <div ref={this.SHARE_SAVE} data-entitlement="SHARE_SAVE" className="save save_mobile">
                            <span className="icon-sprite" role="img" aria-label={docHeaderSectionJson.i18n.floatMenuTooltip_Save}></span>&nbsp;
				            <span>{docHeaderSectionJson.i18n.floatMenuTooltip_Save}</span>
                            <div style={{margin: "0px 60px"}}>
                                <div className="action-holder save-report" onKeyPress={(e) => enterKeyPressed(e, openLink.bind(this, e, 'download'))} onClick={(event: any) => openLink(event, 'download')}>
                                    <a tabIndex={0} aria-label={docHeaderSectionJson.i18n.floatMenuTooltip_SaveReport}>{docHeaderSectionJson.i18n.floatMenuTooltip_SaveReport}</a>
                                </div>
                                <div className="action-holder save-to-reading-list" onKeyPress={(e) => enterKeyPressed(e, saveReportForOffline.bind(this))} onClick={() => saveReportForOffline()}>
                                  <a tabIndex={0} aria-label={docHeaderSectionJson.i18n.floatMenuTooltip_SaveToReadingList}>{docHeaderSectionJson.i18n.floatMenuTooltip_SaveToReadingList}</a>
                                </div>
                                <div className="action-holder view-reading-list" onKeyPress={(e) => enterKeyPressed(e, openViewReadingList.bind(this))} onClick={() => openViewReadingList()}>
                                    <a tabIndex={0} aria-label={docHeaderSectionJson.i18n.floatMenuTooltip_ViewReadingList}>{docHeaderSectionJson.i18n.floatMenuTooltip_ViewReadingList}</a>
                                </div>
                            </div>
                        </div>
                    )}
                    {this.showSave() && !hiddenSaveReport &&
                        (<div ref={this.SHARE_SAVE}
                              className="action-holder save save_pc"
                              data-entitlement="SHARE_SAVE"
                              onKeyPress={(e) => enterKeyPressed(e, openLink.bind(this, e, 'download'))}
                              onClick={(event: any) => openLink(event, 'download')}
                              tabIndex={0} role="button"
                              aria-label={docHeaderSectionJson.i18n.save}
                         >
                            <span title={docHeaderSectionJson.i18n.save} className={iconClass} role="img" aria-label={docHeaderSectionJson.i18n.save}></span>&nbsp;
                            {!hiddenText && <a tabIndex={0} className="x-rsch-hyperlink" aria-label={docHeaderSectionJson.i18n.save}>{docHeaderSectionJson.i18n.save}</a>}
                        </div>)
                    }
                    {this.showOfflineReadingOption() && !hiddenReadingList &&
                        (<div id="offline-reading-web"
                              ref={this.OFFLINE_READING_WEB}
                              data-entitlement="OFFLINE_READING"
                              className="action-holder"
                              onKeyPress={(e) => enterKeyPressed(e, openLink.bind(this, e, 'offlineReading'))}
                              onClick={(event: any) => openLink(event, 'offlineReading')}
                              tabIndex={0} role="button"
                              aria-label={docHeaderSectionJson.i18n.addToReadingList}
                         >
                            <span title={docHeaderSectionJson.i18n.addToReadingList} className="icon-offline-reading" role="img" aria-label={docHeaderSectionJson.i18n.addToReadingList}></span>&nbsp;
                            {!hiddenText && <a tabIndex={0} className="x-rsch-hyperlink" aria-label={docHeaderSectionJson.i18n.addToReadingList}>{docHeaderSectionJson.i18n.addToReadingList}</a>}
                        </div>)
                    }
                    {this.showOfflineReadingOption() && !hiddenReadingList &&
                        (<div id="offline-reading-mobile"
                              ref={this.OFFLINE_READING_MOBILE}
                              data-entitlement="OFFLINE_READING"
                              className="action-holder"
                              onKeyPress={(e) => enterKeyPressed(e, openLink.bind(this, e, 'offlineReading'))}
                              onClick={(event: any) => openLink(event, 'offlineReading')}
                              tabIndex={0} role="button"
                              aria-label={docHeaderSectionJson.i18n.addToReadingList}
                         >
                            <span title={docHeaderSectionJson.i18n.addToReadingList} className="icon-offline-reading" role="img" aria-label={docHeaderSectionJson.i18n.addToReadingList}></span>&nbsp;
                            {!hiddenText && <a className="x-rsch-hyperlink" aria-label={docHeaderSectionJson.i18n.addToReadingList}>{docHeaderSectionJson.i18n.addToReadingList}</a>}
                        </div>)
                    }
                    {this.showManageSubscription() &&
                        (<div ref={this.SHARE_MANAGE_SUBSCRIPTIONS}
                              data-entitlement="SHARE_MANAGE_SUBSCRIPTIONS"
                              className="action-holder manage-subscriptions"
                              onKeyPress={(e) => enterKeyPressed(e, openLink.bind(this, e, 'managesubscription'))}
                              onClick={(event: any) => openLink(event, 'managesubscription')}
                              tabIndex={0} role="button"
                              aria-label={docHeaderSectionJson.i18n.manage_subscription}
                         >
                            <span title={docHeaderSectionJson.i18n.manage_subscription} className={iconClass} role="img" aria-label={docHeaderSectionJson.i18n.manage_subscription}></span>&nbsp;
                            {!hiddenText && <a id="manage-subscriptions-help" className="x-rsch-hyperlink" aria-label={docHeaderSectionJson.i18n.manage_subscription}>{docHeaderSectionJson.i18n.manage_subscription}</a>}
                        </div>)
                    }
                    <div ref={this.SHARE_FEEDBACK}
                         data-entitlement="SHARE_FEEDBACK"
                         className="action-holder feedback"
                         onKeyPress={(e) => enterKeyPressed(e, openLink.bind(this, e, 'feedback'))}
                         onClick={(event: any) => openLink(event, 'feedback')}
                         tabIndex={0} role="button"
                         aria-label={docHeaderSectionJson.i18n.feedback}
                    >
                        <span title={docHeaderSectionJson.i18n.feedback} className={iconClass} role="img" aria-label={docHeaderSectionJson.i18n.feedback}></span>&nbsp;
                        {!hiddenText && <a className="x-rsch-hyperlink" aria-label={docHeaderSectionJson.i18n.feedback}>{docHeaderSectionJson.i18n.feedback}</a>}
                    </div>
                    {this.showUpdateContactDetails() &&
                        (<div ref={this.SHARE_UPDATE_CONTACT_DETAILS}
                              data-entitlement="SHARE_UPDATE_CONTACT_DETAILS"
                              className="action-holder update-contact-details"
                              onKeyPress={(e) => enterKeyPressed(e, this.openModal.bind(this, e))}
                              onClick={(e) => this.openModal(e)}
                              tabIndex={0} role="button"
                              aria-label={docHeaderSectionJson.i18n.update_contact_details}
                         >
                            {this.state.modalStatus &&
                                <FormPopup showOldBranding={this.props.showOldBranding} titleSource={docHeaderSectionJson.i18n.update_contact_details} typeIdentifier={'Update Contact'} closeable={true}/>
                            }
                            <span title={docHeaderSectionJson.i18n.update_contact_details} className={iconClass} role="img" aria-label={docHeaderSectionJson.i18n.update_contact_details}></span>&nbsp;
                            {!hiddenText && <a className="x-rsch-hyperlink" aria-label={docHeaderSectionJson.i18n.update_contact_details}>{docHeaderSectionJson.i18n.update_contact_details}</a>}
                        </div>)
                    }
                    <div ref={this.SHARE_HELP}
                         data-entitlement="SHARE_HELP"
                         className="action-holder help"
                         onKeyPress={(e) => enterKeyPressed(e, openLink.bind(this, e, 'help'))}
                         onClick={(event: any) => openLink(event, 'help')}
                         tabIndex={0} role="button"
                         aria-label={docHeaderSectionJson.i18n.help}
                    >
                        <span title={docHeaderSectionJson.i18n.help} className={iconClass} role="img" aria-label={docHeaderSectionJson.i18n.help}></span>&nbsp;
                        {!hiddenText && <a className="x-rsch-hyperlink" aria-label={docHeaderSectionJson.i18n.help}>{docHeaderSectionJson.i18n.help}</a>}
                    </div>
                    <div ref={this.SHARE_COOKIES_POLICY}
                         data-entitlement="SHARE_COOKIES_POLICY"
                         onKeyPress={(e) => enterKeyPressed(e, switchPage.bind(this, 'cookiesPolicyPage', 'moreTab'))}
                         onClick={() => switchPage('cookiesPolicyPage', 'moreTab')}
                         className="action-holder cookies-policy"
                         tabIndex={0} role="button"
                         aria-label={docHeaderSectionJson.i18n.cookies_policy}
                    >
                        <span title={docHeaderSectionJson.i18n.cookies_policy} className={iconClass} role="img" aria-label={docHeaderSectionJson.i18n.cookies_policy}></span>&nbsp;
                        {!hiddenText && <a className="x-rsch-hyperlink" aria-label={docHeaderSectionJson.i18n.cookies_policy}>{docHeaderSectionJson.i18n.cookies_policy}</a>}
                    </div>
                    {this.props.initialData.show_privacy_policy &&
                        (<div ref={this.SHARE_PRIVACY_POLICY}
                              data-entitlement="SHARE_PRIVACY_POLICY"
                              onKeyPress={(e) => this.props.initialData?.privacyStatementUrl ? enterKeyPressed(e, openLink.bind(this, e, 'privacyStatementUrl')) :  enterKeyPressed(e, switchPage.bind(this, 'privacyPolicyPage', 'moreTab'))}
                              onClick={(e) => this.props.initialData?.privacyStatementUrl ? openLink(e,'privacyStatementUrl') : switchPage('privacyPolicyPage', 'moreTab')}
                              className="action-holder privacy-policy"
                              tabIndex={0} role="button"
                              aria-label={docHeaderSectionJson.i18n.cookies_policy}
                         >
                            <span title={docHeaderSectionJson.i18n.privacy_policy} className={iconClass} role="img" aria-label={docHeaderSectionJson.i18n.privacy_policy}></span>&nbsp;
                            {!hiddenText && <a className="x-rsch-hyperlink" aria-label={docHeaderSectionJson.i18n.privacy_policy}>{docHeaderSectionJson.i18n.privacy_policy}</a>}
                        </div>)
                    }
                    {this.showCompatibilityTest() &&
                        (<div ref={this.COMPATIBILITY_TEST}
                              data-entitlement="COMPATIBILITY_TEST"
                              className="action-holder compatibility_test"
                              onKeyPress={(e) => enterKeyPressed(e, openNewTestPage.bind(this))}
                              onClick={() => openNewTestPage()}
                              tabIndex={0} role="button"
                              aria-label={docHeaderSectionJson.i18n.CompatibilityTest}
                         >
                            <span title={docHeaderSectionJson.i18n.CompatibilityTest} className={iconClass} role="img" aria-label={docHeaderSectionJson.i18n.CompatibilityTest}></span>&nbsp;
                            {!hiddenText && <a className="x-rsch-hyperlink" aria-label={docHeaderSectionJson.i18n.CompatibilityTest}>{docHeaderSectionJson.i18n.CompatibilityTest}</a>}
                        </div>)
                    }
                </div>
            </div>
        </span>;
    }
}

const mapStateToProps = (state: IReducerState) => {
    return {
        docHeaderSectionJson: state.asyncStateReducer.docHeaderJsonData,
        initialData: state.asyncStateReducer.initialData,
    };
};

export default connect(mapStateToProps)(More);
